import React from 'react';
import {Route} from 'react-router-dom';
import AsyncTerms from './async';
import DefaultBusinessLayout from '../../../../../components/layout/DefaultBusinessLayout';

export default (
  <Route
    key="/business/shopify/terms"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Shopify Terms',
            item: '/business/shopify/terms',
          },
        ]}
      />
    }
  >
    <Route path="business/shopify/terms" element={<AsyncTerms />} />
  </Route>
);
